document.addEventListener 'DOMContentLoaded', ->

  # --- Akce po "kliknutí" (ručně volaná) ---
  handleSelect = (btn) ->
    return unless btn?
    $('.themes_photo_product_selector').removeClass 'active'
    $(btn).addClass 'active'
    containerReload(true)


  $(document).on 'change', '.theme_filter', ->
    containerReload()

  $(document).on 'mouseover', '.theme_image', (e) ->

    console.log 'mouseover'

    if $(this).data('other_images') == 0
        return false

    imgElement = $(this)
    imgSrc = imgElement.attr('src')
    
    baseSrc = imgSrc.replace(/-\d\.jpg$/, '')  # Odstraní aktuální index

    images = []

    for i in [1..$(this).data('other_images')]
      images.push "#{baseSrc}-#{i}.jpg"


    console.log(images)


    cycleImages(imgElement, images)

  $(document).on 'mouseout', '.theme_image', (e) ->

      if $(this).data('other_images') == 0
          return false

      imgElement = $(this)
      stopCycleImages(imgElement)
      # Nastav původní obrázek zpět

      imgElement.attr 'src', imgElement.data 'base_img'

  # --- AJAX RELOAD ---
  containerReload = (refresh_filter = false) ->
    container = $('#themesContainerWrapper')
    active = $('.themes_photo_product_selector.active').data('photo_product') or null
    
    filters = $('input[name="theme_filter[]"]:checked')
      .map((_, el) => el.value)
      .get();

    console.log(filters);

    if (refresh_filter)
      $('input.theme_filter').prop('checked', false)



    $.ajax(
      url: '/ajax/themes_container_reload/'
      type: 'POST'
      dataType: 'JSON'
      data:
        filters: filters
        photo_product: active
        in_app: $('input[name=themes_in_app]').val()
        app_photo_product: $('input[name=themes_app_photo_product]').val()
        app_product_id: $('input[name=app_product_id]').val()

    ).done((data) ->
      console.log(data)

      $('.theme_filter_pill').addClass 'hidden'
      for filter in data.available_filters
        console.log('input.theme_filter[value=' + filter + ']')
        $('.theme_filter_pill#f_pill_' + filter).removeClass 'hidden'


      container.html data.html_output
      # $('.scrollbar').scrollbar();
    ).fail (jqXHR) ->
      console.error jqXHR.responseText

  containerReload(true)

  # --- SCROLL / DRAG HANDLING ---
  track = document.getElementById 'sizesTrack'
  btnL  = document.getElementById 'navLeft'
  btnR  = document.getElementById 'navRight'
  return unless track? and btnL? and btnR?

  # Šipky
  updateArrows = ->
    maxScroll = track.scrollWidth - track.clientWidth
    btnL.disabled = track.scrollLeft <= 1
    btnR.disabled = track.scrollLeft >= maxScroll - 1

  scrollByAmount = (px) ->
    track.scrollBy left: px, behavior: 'smooth'

  btnL.addEventListener 'click', -> scrollByAmount -Math.max(240, track.clientWidth * 0.6)
  btnR.addEventListener 'click', -> scrollByAmount  Math.max(240, track.clientWidth * 0.6)

  track.addEventListener 'scroll', updateArrows
  window.addEventListener 'resize', updateArrows
  updateArrows()

  # --- "Klik přes pointerup" + drag ---
  isDown = false
  moved = false
  startX = 0
  startLeft = 0
  downTargetBtn = null
  DRAG_THRESHOLD = 5

  # Pro jistotu zamez defaultním dragům obrázků atd.
  track.addEventListener 'dragstart', (e) -> e.preventDefault()

  track.addEventListener 'pointerdown', (e) ->
    isDown = true
    moved = false
    startX = e.clientX
    startLeft = track.scrollLeft
    downTargetBtn = e.target.closest('.themes_photo_product_selector')  # co bylo pod prstem při stisku
    track.setPointerCapture e.pointerId
    document.body.style.userSelect = 'none'

  track.addEventListener 'pointermove', (e) ->
    return unless isDown
    dx = e.clientX - startX
    if Math.abs(dx) > DRAG_THRESHOLD then moved = true
    track.scrollLeft = startLeft - dx

  track.addEventListener 'pointerup', (e) ->
    if track.hasPointerCapture(e.pointerId)
      track.releasePointerCapture e.pointerId
    document.body.style.userSelect = ''
    isDown = false

    # Pokud jsme NETÁHLI → bereme target z pointerdown a provedeme akci
    unless moved
      if downTargetBtn?
        handleSelect(downTargetBtn)
    downTargetBtn = null

  track.addEventListener 'pointercancel', ->
    isDown = false
    document.body.style.userSelect = ''
    downTargetBtn = null

  # --- Klávesnice pro přístupnost (Enter/Space na buttonu) ---
  document.addEventListener 'keydown', (e) ->
    return unless e.target?.matches('.themes_photo_product_selector')
    if e.key is 'Enter' or e.key is ' '
      e.preventDefault()
      handleSelect(e.target)
